export default __webpack_public_path__ + "static/media/Next IT - Comple (4).3707499d.png";